import React from "react";
import { withAllContexts } from "../../../AllContextsWrapper"
import PluginRegistry from '../../../plugins';

class ReservationData extends React.Component {

    render() {
        const plugin = PluginRegistry.get(this.props.app.state.activeCalendar?.type || 'rafting');
        const PluginReservationData = plugin.ReservationData;

        if (!PluginReservationData) return null;

        return (
            <PluginReservationData {...this.props} />
        );
    }
}

export default withAllContexts(ReservationData);
